import { EmbeddedContentDefinition } from 'modules/graphql';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { getIsEditMode } from 'modules/templateEditor/common';
import { DISPLAY_CONTENT } from '../constants';
import { getCharacterCountText } from '../utils';
import { TextAreaField } from './components';

export const Body = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  const { body: embeddedBody } = liveTemplate.mediumData as EmbeddedContentDefinition;

  const body = embeddedBody || '';

  const setBody = (updatedBody: string) =>
    setCurrentMediumField('body', updatedBody.length ? updatedBody : null);

  return (
    <TextAreaField
      isEditMode={isEditModeVisible}
      label={DISPLAY_CONTENT.settings.formBodyLabel}
      mediumDataKey="body"
      mediumDataValue={body}
      setMediumDataValue={setBody}
      restrictionText={getCharacterCountText(body)}
    />
  );
};
